export default __webpack_public_path__ + "970f248aad65b2eceba3a314b81735ec.svg";